import { defineMessages } from "react-intl";

export const messages = defineMessages({
  createApp: {
    id: "agZQkB",
    defaultMessage: "Create App",
    description: "window title",
  },
});
